import styled from "styled-components";

export const Container = styled.main`
  padding: 2rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 1.5rem;
  }
`;

export const Content = styled.section`
  margin-top: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin-top: 0;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  margin-bottom: 0.75rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  gap: 0.5rem;
`;
